import { z } from "zod"

export const TestWebhookSchema = z.object({
  url: z.string(),
  payload: z.string(),
  headers: z.array(
    z.object({
      key: z.string(),
      value: z.string(),
    }),
  ),
  context: z.record(z.string(), z.unknown()).optional(),
})
